import createLink from '@anm/helpers/createLink';

type HookProps = {
  data: string | string[][][];
  fileName?: string;
};

let dataCsv: string;

const getCsvCell = (value: string) => `${value}`.trim();

const makeRow = (row: string[]) =>
  row.reduce((rowAcc, cell) => (rowAcc ? `${rowAcc}${getCsvCell(cell)}\n` : `${getCsvCell(cell)}\n`), '');

const makeTable = (table: string[][]) =>
  table.reduce((tableAcc, row) => {
    const rowStr = makeRow(row);

    return `${tableAcc}${rowStr}`;
  }, '');

const useDownloadCSV = ({ data, fileName = 'downloaded.csv' }: HookProps) => {
  const csvContentStart = 'data:text/csv;charset=utf-8,';
  const isArrayData = typeof data === 'object';

  if (isArrayData) {
    dataCsv = (data as string[][][]).reduce((acc, tableData) => {
      const tableStr = makeTable(tableData);

      return `${acc}${tableStr}`;
    }, csvContentStart);
  }

  const [link, cleanLink] = createLink(isArrayData ? dataCsv : `${csvContentStart}${data}`);
  link.setAttribute('download', fileName);

  return () => {
    link.click();
    cleanLink();
  };
};

export default useDownloadCSV;
